module.exports = __webpack_public_path__ + "static/media/listLayout.94e9cc0f.svg";